import React, { FC } from 'react';
import styles from './Browser.scss';
import { ChevronLeftSmall, ChevronRightSmall, CircleSmallFilledSmall } from '@wix/wix-ui-icons-common';
import { Text } from '@wix/design-system';

type Props = {
  url?: string;
};

export const BrowserHeader: FC<Props> = ({ url }) => {
  return (
    <div className={styles.browserHeader}>
      <div className={styles.browserHeaderKnobs}>
        <CircleSmallFilledSmall />
        <CircleSmallFilledSmall />
        <CircleSmallFilledSmall />
      </div>
      {url && (
        <div className={styles.browserHeaderUrl}>
          <Text secondary size="tiny">
            {url}
          </Text>
        </div>
      )}
      <div className={styles.browserHeaderKnobs}>
        <ChevronLeftSmall />
        <ChevronRightSmall />
      </div>
    </div>
  );
};
